import { Building2 } from 'lucide-react';
import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu';
import { useEntitlements, useSession } from '@/lib/entitlements';
import { resolveEnabledModules } from '@/lib/modules';
import { PLAN_LABELS } from '@/types';

/**
 * Organisation switcher — for us, and in development.
 *
 * It was compiled out of the production bundle entirely (`import.meta.env.DEV`),
 * which was fine while the only multi-organisation accounts were test ones. It
 * is not fine now: a member of two organisations would be locked into whichever
 * one loaded first, with no way back.
 *
 * Ribox staff see it because switching client is how they work. Anyone else
 * sees it only if they really do belong to more than one organisation — and in
 * development, where flipping between tenants in one click is the only way to
 * check that a client's plan actually reshapes the product.
 */
export function TenantSwitcherMenu() {
  const { tenants, tenantId, selectTenant } = useSession();
  const { platformRole } = useEntitlements();
  if (tenants.length < 2) return null;
  if (platformRole === null && !import.meta.env.DEV) return null;

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <Building2 className="size-4 text-muted-foreground" />
        Cambiar organización
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        <DropdownMenuRadioGroup value={tenantId ?? ''} onValueChange={selectTenant}>
          {tenants.map((tenant) => {
            // Resuelto y no crudo, por lo mismo que en el selector de
            // organización de la pantalla completa (`app/tenant-picker-page.tsx`):
            // la lista escrita en el documento incluye ids que esta organización
            // nunca va a ver —retirados, sin construir, o sin su sistema— y
            // contarlos promete un menú más grande del que hay.
            const modulos = resolveEnabledModules(tenant.enabledModules).size;
            return (
              <DropdownMenuRadioItem key={tenant.id} value={tenant.id}>
                <span className="flex min-w-0 flex-col">
                  <span className="truncate">{tenant.name}</span>
                  <span className="truncate text-xs text-muted-foreground">
                    Plan {PLAN_LABELS[tenant.plan]} · {modulos}{' '}
                    {modulos === 1 ? 'módulo' : 'módulos'}
                  </span>
                </span>
              </DropdownMenuRadioItem>
            );
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
